import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { createMiddleware } from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';
import { getEventMap } from './analytics';
import { configureStore } from '@reduxjs/toolkit';
import CartSlice from './Slices/CartSlice';
import CartPageDataSlice from './Slices/CartPageDataSlice';
import Cart from './components/Cart.jsx';

export const store = configureStore({
  reducer: {
    Cart: CartSlice,
    CartPageData: CartPageDataSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(createMiddleware(getEventMap(), GoogleTagManager())),
  devTools: {
    name: `Cart - ${document.title} (${window.location.href})`,
  },
});

const cartContainer = document.getElementById('REACT_cart');
if (cartContainer) {
  const root = createRoot(cartContainer);
  root.render(
    <Provider store={store}>
      <Sentry.ErrorBoundary>
        <Cart />
      </Sentry.ErrorBoundary>
    </Provider>
  );
}
